







"use strict";

const {defaultReadyHandler} = require("./ready-handler.js");
const httpUtil = require("./http-util.js");
const {ajax} = require("./ajax-util");
const {WebStorageManager} = require("./webstorage-util");
const storage = new WebStorageManager();





class AuthHandler {
    





    constructor(readyHandler = null) {
        this.readyHandler = readyHandler || defaultReadyHandler;
    }

    





    saveloginData(data) {
        const redirectUri = "redirect_uri";
        data.authParams[redirectUri] = httpUtil.resolveUrl(data.authParams[redirectUri]);
        
        let url = httpUtil.toQueryUrl(data.urlBase, data.authParams);
        data.goto = data.goto || window.location.href;
        
        const confirmGotoUri = "confirm_goto_uri";
        let privacyPolicyParams = {
            goto: httpUtil.resolveUrl(data.confirmParams[confirmGotoUri]),
            "service_cd": "PTP"
        };
        data.privacyPolicyUrl = httpUtil.toQueryUrl(data.privacyPolicy, privacyPolicyParams);
        storage.setItem("loginData", JSON.stringify(data));
        return url;
    }

    











    moveToLoginPage(data) {
        window.location = this.saveloginData(data);
    }

    







    defaultLoginCallback(thenCb = null) {
        return ajax({
            url: httpUtil.getApiUrl("/spfauth/spfLoginInfo"),
            dataType: "json"
        }).then(thenCb || (data => {
            this.moveToLoginPage(data);
        }));
    }

    getLoginStatus() {
        return storage.getItem("sessionStatus");
    }

    isLoginSucceeded(sessionStatus) {
        if (!sessionStatus) {
            sessionStatus = this.getLoginStatus();
        }
        return (sessionStatus === "ok");
    }

    







    checkLogined(callback = null) {
        callback = callback || this.defaultLoginCallback.bind(this);

        this.readyHandler.addState("auth", true);
        let sessionStatus = this.getLoginStatus();
        let appSessionBearer = storage.getItem("appSessionBearer");
        try {
            if (!sessionStatus) {
                callback(); 
            } else if (this.isLoginSucceeded(sessionStatus) && appSessionBearer) {
                this.readyHandler.changeState("auth");
            } else {
                this.readyHandler.changeState("auth");
                let errorDetail = this.isLoginSucceeded(sessionStatus) ?
                        {type: "serverError", title: "missed session bearer"}
                        : JSON.parse(sessionStatus);
                errorDetail.needReLogin = storage.getItem("reloginOnError");
                storage.removeItem("reloginOnError");
                throw errorDetail;
            }
            return this.getSession();
        } catch (e) {
            this.clear();
            throw e;
        }
    }

    






    getSession() {
        return JSON.parse(storage.getItem("appSessionContent") || "null");
    }

    






    setSession(session) {
        console.log(session);
        storage.setItem("appSessionContent", JSON.stringify(session || null));
    }

    





    logined(appSession = null) {
        this._setSessionStatus("ok", appSession);
    }

    



    clear() {
        this._setSessionStatus(null);
    }

    _setSessionStatus(status, session) {
        if (status) {
            storage.setItem("sessionStatus", status);
            storage.setItem("appSessionContent", session);
            storage.removeItem("state");
        } else {
            
            storage.clear();
        }
    }

    






    ajaxAuth(ajaxOption) {
        let appSessionBearer = storage.getItem("appSessionBearer");
        if (appSessionBearer) {
            ajaxOption = httpUtil.addHeader(ajaxOption, "Authorization", appSessionBearer);
        }
        return ajax(ajaxOption).catch(err => {
            if (err.status === 401 || err.status === 403) {
                err.needReLogin = (err.status === 401);
                this.clear();
            }
            throw err;
        });
    }
}

module.exports = {
    AuthHandler
};
